var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "v-container",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showFiltroAsociado,
              expression: "showFiltroAsociado"
            }
          ],
          attrs: { "grid-list-xs": "" }
        },
        [
          _c(
            "v-card",
            {
              staticClass: "pa-3 d-flex align-center",
              attrs: {
                "justify-center": "",
                color: "#27488E",
                dark: "",
                icon: "$mdiVuetify"
              }
            },
            [
              _vm._v(
                "\n      Esta asociada con transportista mediante la selección de\n      " +
                  _vm._s(
                    this.Plataformas.getNombrePorIdFiltros(this.filtroKey)
                  ) +
                  " , al\n      momento de desasociar se eliminara este registro.\n    "
              )
            ]
          )
        ],
        1
      ),
      _c(
        "v-container",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.showFiltroAsociado,
              expression: "!showFiltroAsociado"
            }
          ],
          attrs: { "grid-list-xs": "" }
        },
        [
          _c(
            "div",
            { staticClass: "mx-3" },
            [
              _c("v-text-field", {
                attrs: {
                  name: "busqueda",
                  "append-icon": "search",
                  label: "Búsqueda.",
                  "single-line": "",
                  "hide-details": ""
                },
                on: { input: _vm.onFilterTextBoxChanged },
                model: {
                  value: _vm.search,
                  callback: function($$v) {
                    _vm.search = $$v
                  },
                  expression: "search"
                }
              })
            ],
            1
          ),
          _c("v-divider"),
          _c("ag-grid-vue", {
            staticClass: "ag-theme-material",
            staticStyle: { width: "auto", height: "200px" },
            attrs: {
              columnDefs: _vm.columnDefs,
              rowData: _vm.rowData,
              rowSelection: "multiple"
            },
            on: {
              "row-selected": _vm.onRowSelected,
              "grid-ready": _vm.onGridReady
            }
          })
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.showFiltroAsociado,
              expression: "!showFiltroAsociado"
            }
          ]
        },
        [
          _c(
            "div",
            { staticStyle: { "max-height": "4px" } },
            [
              _c("v-progress-linear", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.cargando,
                    expression: "cargando"
                  }
                ],
                attrs: { indeterminate: "", color: "primary" }
              })
            ],
            1
          ),
          _c(
            "v-btn",
            {
              staticClass: "error",
              staticStyle: { "padding-right": "20px" },
              attrs: { disabled: _vm.disabled },
              on: { click: _vm.desasociar }
            },
            [
              _c("v-icon", { staticStyle: {}, attrs: { dark: "", left: "" } }, [
                _vm._v("cancel")
              ]),
              _c("span", [_vm._v("Desasociar")])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showFiltroAsociado,
              expression: "showFiltroAsociado"
            }
          ]
        },
        [
          _c(
            "v-btn",
            {
              staticClass: "error",
              staticStyle: { "padding-right": "20px" },
              attrs: { disabled: !_vm.showFiltroAsociado },
              on: { click: _vm.desasociar }
            },
            [
              _c("v-icon", { staticStyle: {}, attrs: { dark: "", left: "" } }, [
                _vm._v("cancel")
              ]),
              _c("span", [_vm._v("Desasociar filtro asignado")])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }